import { CountryEnum } from './enums';

export const SHIPPING_LABEL_COUNTRIES: CountryEnum[] = [
  CountryEnum.Germany,
  CountryEnum.Austria,
  CountryEnum.Netherlands,
];
